import React, { Component } from 'react';
import { withApollo } from '@apollo/react-hoc';
import ProductLayout from '$components/layout/ProductLayout';
import Seo from '$components/Seo';
import ReferralRewards from './ReferralRewards';
import UpdateNicknameForm from './UpdateNicknameForm';
import UpdatePasswordForm from './UpdatePasswordForm';

import styles from './styles.scss';

class UserAccount extends Component {
  render() {
    const { currentUser, location, match } = this.props;
    const { client } = this.props;
    const { email } = currentUser;

    return (
      <>
        <Seo title="User account" canonical={null} description={null} />
        <ProductLayout currentUser={currentUser} location={location} match={match}>
          {() => (
            <div className={styles.layout}>
              <div className={styles.well}>
                <h1 className={styles.header}>User account</h1>
                <p>Signed in as: {email}</p>
                <div className={styles.description}>
                  <h2 className={styles.subheader}>Refer and earn</h2>
                  <ReferralRewards currentUser={currentUser} />
                  <h2 className={styles.subheader}>Nickname</h2>
                  <UpdateNicknameForm client={client} currentUser={currentUser} />
                  <h2 className={styles.subheader}>Password</h2>
                  <UpdatePasswordForm client={client} currentUser={currentUser} />
                </div>
              </div>
            </div>
          )}
        </ProductLayout>
      </>
    );
  }
}

export default withApollo(UserAccount);
